/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_OpenInputs */

const th_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด`)
};

const en_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const ja_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

const zh_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开`)
};

const es_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const pt_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const id_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const fr_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

const tl_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan`)
};

const vi_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở`)
};

const ko_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`열기`)
};

const de_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen`)
};

const ru_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть`)
};

const tr_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aç`)
};

const it_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri`)
};

const pl_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz`)
};

const uk_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити`)
};

const hi_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोलें`)
};

const ar_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح`)
};

const ms_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const bn_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খুলুন`)
};

const zh_tw2_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟`)
};

const zh_hk2_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟`)
};

const ur_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھولیں`)
};

const fa_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باز کردن`)
};

const sw_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua`)
};

const nl_meeting_open = /** @type {(inputs: Meeting_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Meeting_OpenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_open = /** @type {((inputs?: Meeting_OpenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_OpenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_open(inputs)
	if (locale === "ja") return ja_meeting_open(inputs)
	if (locale === "zh") return zh_meeting_open(inputs)
	if (locale === "es") return es_meeting_open(inputs)
	if (locale === "pt") return pt_meeting_open(inputs)
	if (locale === "id") return id_meeting_open(inputs)
	if (locale === "fr") return fr_meeting_open(inputs)
	if (locale === "tl") return tl_meeting_open(inputs)
	if (locale === "vi") return vi_meeting_open(inputs)
	if (locale === "ko") return ko_meeting_open(inputs)
	if (locale === "de") return de_meeting_open(inputs)
	if (locale === "ru") return ru_meeting_open(inputs)
	if (locale === "tr") return tr_meeting_open(inputs)
	if (locale === "it") return it_meeting_open(inputs)
	if (locale === "pl") return pl_meeting_open(inputs)
	if (locale === "uk") return uk_meeting_open(inputs)
	if (locale === "hi") return hi_meeting_open(inputs)
	if (locale === "ar") return ar_meeting_open(inputs)
	if (locale === "ms") return ms_meeting_open(inputs)
	if (locale === "bn") return bn_meeting_open(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_open(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_open(inputs)
	if (locale === "ur") return ur_meeting_open(inputs)
	if (locale === "fa") return fa_meeting_open(inputs)
	if (locale === "sw") return sw_meeting_open(inputs)
	if (locale === "nl") return nl_meeting_open(inputs)
	return en_meeting_open(inputs)
});